<template>
  <div>
    <v-card>
      <v-card-title primary-title
        ><v-spacer></v-spacer
        ><v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
              <span style="font-size: 12px">Social</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in social"
              :key="index"
              @click="PieChart(item.value, daterange)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#033666" class="mx-2" dark v-bind="attrs" v-on="on">
              <span style="font-size: 12px">Chart</span>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in chart"
              :key="index"
              @click="ChartChange(item)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="letter-spacing: 0; width: 100%">
        <Pie
          :title="question.questionLabel"
          :data="pie"
          v-if="chart_selected === 'pie'"
        />
        <SingleBarChart
          :title="question.questionLabel"
          :data="pie"
          v-else-if="chart_selected === 'column'"
        />
        <BasicChart v-else :data="basic" />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import BasicChart from "../Chart/BasicChart";
import Pie from "../Chart/Pie";
import SingleBarChart from "../Chart/SingleBarChart.vue";
export default {
  components: { BasicChart, Pie, SingleBarChart },
  props: ["question", "daterange", "modal"],
  watch: {
    daterange(newValue) {
      if (!this.modal) {
        this.PieChart(this.social_selected, newValue);
      }
    },
  },
  data() {
    return {
      chart_selected: "pie",
      social_selected: "ALL",
      social: [
        { title: "All", value: "ALL" },
        { title: "Facebook", value: "FACEBOOK" },
        { title: "Line", value: "LINE" },
        { title: "OneChat", value: "ONECHAT" },
        { title: "Webform", value: "webform" },
      ],
      chart: [
        { title: "Pie Chart", value: "pie" },
        // { title: "Line Chart", value: "line" },
        { title: "Bar Chart", value: "column" },
        // { title: "Stacked Column", value: "stacked" },
      ],
      pie: {
        pointFormat: "{point.name}: <b>{point.y} ครั้ง</b>",
        colors: ["#4064AC", "#00B900", "#4064FF"],
        data: [
          {
            name: "Social",
            colorByPoint: true,
            data: [],
          },
        ],
      },
      basic: {
        stacking: false,
        title: {
          text: this.question.questionLabel,
        },
        subtitle: {
          text: "",
        },
        colors: ["#4064AC", "#00B900", "#4064FF"],
        tooltip: {
          headerFormat: "",
          pointFormat: "{series.name}: {point.y}",
        },
        data: [],
      },
    };
  },
  mounted() {
    this.PieChart(this.social_selected, this.daterange);
    // this.BasicChart(this.social_selected, this.daterange);
  },
  methods: {
    PieChart(social, date) {
      this.$store
        .dispatch("DashboardGetFixtextChart", {
          questionID: this.question.questionID,
          typechart: "piechart",
          social: social,
          daterange: date,
        })
        .then((response) => {
          this.pie.data[0].data = [];
          response.map((d) => {
            this.pie.data[0].data.push({
              name: d.word,
              y: d.value,
            });
          });
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardGetFixtextPieChart)",
              title: "",
            });
          }
        });
    },
    BasicChart(social, date) {
      this.$store
        .dispatch("DashboardGetFixtextChart", {
          questionID: this.question.questionID,
          typechart: "basicchart",
          social: social,
          daterange: date,
        })
        .then((response) => {
          let tempdata = [];
          response.map((d) => {
            tempdata.push({
              name: d.word,
              data: d.value,
              type: "column",
              threshold: null,
              tooltip: {
                valueDecimals: 2,
              },
            });
          });
          this.basic.data = tempdata;
        })
        .catch((err) => {
          if (err.data.message === "Permission Denied") {
            Swal.fire({
              icon: "warning",
              text: "สิทธิ์ของคุณถูกปฏิเสธ",
              title: "",
            }).then(() => {
              this.$store
                .dispatch("CheckPermission")
                .then(async (resp_role) => {
                  if (resp_role.data.permission) {
                    this.$store.commit("UpdateUserPermission", resp_role.data);
                    this.$router.push({
                      name: "question",
                    });
                  }
                });
            });
          } else if (err.data.message === "Survey Not Avaliable.") {
            this.$store.commit("ToggleLoading");
          } else {
            Swal.fire({
              icon: "error",
              text: "ไม่สามารถดูข้อมูลได้ (DashboardGetFixtextBasic)",
              title: "",
            });
          }
        });
    },
    ChartChange(chart) {
      switch (chart.value) {
        case "wordcloud":
          {
            this.chart_selected = "wordcloud";
          }

          break;
        case "pie":
          {
            this.chart_selected = "pie";
          }

          break;
        case "column":
          {
            this.chart_selected = "column";
          }

          break;
        default:
          {
            // console.log("default");
            if (chart.value === "stacked") {
              this.basic.data.map((m) => {
                m.type = "column";
              });
              this.basic.stacking = true;
              this.basic.tooltip = {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat:
                  "{series.name}: {point.y} ({point.percentage:.1f} %)<br/>Total: {point.stackTotal}",
              };
            } else {
              this.basic.data.map((m) => {
                m.type = chart.value;
              });
              this.basic.stacking = false;
              this.basic.tooltip = {
                headerFormat: "<b>{point.x}</b><br/>",
                pointFormat: "{series.name}: {point.y}<br/>",
              };
            }
            this.chart_selected = "basic";
          }
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
